import { render, staticRenderFns } from "./hallDetail.vue?vue&type=template&id=32ba115f&scoped=true"
import script from "./hallDetail.vue?vue&type=script&lang=js"
export * from "./hallDetail.vue?vue&type=script&lang=js"
import style0 from "./hallDetail.vue?vue&type=style&index=0&id=32ba115f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ba115f",
  null
  
)

export default component.exports